import { AbstractDatabaseStatistics } from "./AbstractDatabaseStatistics.js";
import { EssentialIndexInformation } from "./EssentialIndexInformation.js";

export interface EssentialDatabaseStatistics extends AbstractDatabaseStatistics<EssentialIndexInformation> {

}